import styled from "styled-components";

export const Container = styled.footer`
  min-height: 277px;
`;

export const ContactInformations = styled.div`
  background-color: #1d364a;
  height: 203px;
  display: flex;
  justify-content: center;
  padding: 0 20px;

  @media (max-width: 1000px) {
    height: 100%;
    padding: 20px;
  }
`;

export const Content = styled.div`
  max-width: 1262px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;

  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: start;
  }
`;

export const InformationText = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 430px;
  width: 100%;
  color: #f8f6f5;
  gap: 10px;

  h2 {
    font-size: 24px;
    font-family: "Noto Serif";
  }
  span {
    font-family: "Montserrat";
  }
`;

export const Contact = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 15px;
  gap: 10px;

  a,
  div {
    color: #f8f6f5;
    display: flex;
    gap: 10px;
    font-family: "Montserrat";
  }

  a {
    text-decoration: none;
  }

  @media (max-width: 425px) {
    font-size: 13px;
  }
`;

export const FooterInformations = styled.div`
  height: 78px;
  background-color: #139ed5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-family: "Montserrat";
  font-size: 13px;
  padding: 0 20px;

  a {
    font-weight: bold;
    color: white;
    text-decoration: none;
  }
`;
